import React from "react";
import { SHr, SNavigation, SPage, SPopup, SText, SView } from "servisofts-component2";
// import BottomNavigator from "../../Components/BottomNavigator";
import PButtom from "../../Components/PButtom";
import Input from "../../Components/Input";
import { StyleSheet } from "react-native";
import MDL from "../../MDL";

export default class recuperar extends React.Component {
    // static FOOTER = <BottomNavigator url={"/login"} />
    constructor(props) {
        super(props);
        this.state = {
        };
        this.key = SNavigation.getParam("key");
        this.key_rol = SNavigation.getParam("key_rol");
        if (!this.key_rol) {
            this.key_rol = "d16d800e-5b8d-48ae-8fcb-99392abdf61f";
        }
    }

    inputRefs = {};
    getForm() {
        return <>
            {/* <SForm
                ref={(ref) => { this.form = ref; }}
                row
                style={{
                    justifyContent: "space-between",
                }}
                inputProps={{
                    col: "xs-12",
                }}
                inputs={{
                    correo: { placeholder: "email@example.com", type: "email", isRequired: true },
                }}
                onSubmit={(values) => {
                    Model.usuario.Action.recuperarPass({ correo: values.correo }).then(resp => {
                        SNavigation.navigate("/login/recuperar_codigo");
                    }).catch(e => {
                        console.error(e);
                    })
                }}
            /> */}
            <Input
                ref={(ref) => this.inputRefs["correo"] = ref}
                placeholder="email@example.com"
                required
                style={styles.input}
            />
            <SView height={16} />
            <SView col={"xs-11"} row center>
                <PButtom primary onPress={() => {
                    let data = {};
                    let vacio = false;
                    let email = this.inputRefs["correo"];
                   
                        if (!email.validar()) {
                            vacio = true;
                            SPopup.alert("Por favor, ingrese su correo electrónico.");
                            return;
                        }
                    
                    if (!vacio) {
                        MDL.usuario.recuperarPass(
                            email.getValue(),
                        ).then((resp) => {
                            if (resp.estado === "exito") {

                               SNavigation.navigate("/login/recuperar_codigo");
                            } else {
                                SPopup.alert("Error en los datos");
                            }
                        }).catch((e) => {
                            console.error(e);
                            SPopup.alert("Error en los datos");
                        })
                        console.log("data", data);

                    }


                }}>Enviar código</PButtom>
            </SView>
        </>
    }

    render() {
        return <SPage title={"Recuperar Contraseña"}>
            <SView center>
                <SView col={"xs-11 md-6 xl-4"} center>
                    <SView height={40} />
                    <SText fontSize={16} center>Le enviaremos un mensaje para configurar o restablecer su nueva contraseña. </SText>
                    <SView height={40} />
                    {this.getForm()}

                    <SHr />
                    <SHr />
                    <SHr />
                    <SView col={"xs-11"} row center onPress={() => {
                        // SNavigation.navigate("/login/recuperar_codigo");
                        SNavigation.navigate("/login/recuperar_pass");
                    }}>
                        <SText fontSize={14} style={{
                            textDecorationLine: "underline",
                        }}>Ya tengo un código!</SText>
                    </SView>
                    <SView height={36} />
                </SView>
            </SView>
        </SPage>
    }
}
const styles = StyleSheet.create({
    input: {
        width: "100%",
    },
});